import { useCallback, useContext, useMemo } from 'react';

import ScopeContext from 'ia-react-core/~/components/redux/_ScopeContext/ScopeContext';
import get from 'ia-react-core/~/utils/accessors/get';
import getScoped from 'ia-react-core/~/utils/redux/getScoped';

export interface UseScopeMock {
  mockState: (state: Record<string, any>) => void;
  mockScope: (scope: string[]) => void;
  state: Record<string, any>;
  scope: string[];
  store: {
    getState: () => Record<string, any>;
    dispatch: (...args: unknown[]) => void;
    subscribe: (...args: unknown[]) => void;
  };
}

const useScope = () => {
  const { store, scope } = useContext(ScopeContext);

  const getScopedState = useCallback(<SelectedState, State>(pathOrFn?: string | ((state: State) => SelectedState)): SelectedState => {
    const state = store.getState();

    if (typeof pathOrFn === 'function') {
      const scopedState = scope.length ? get(state, scope) : state;
      return pathOrFn(scopedState);
    } if (!pathOrFn) {
      const scopedState = scope.length ? get(state, scope) : state;
      return scopedState;
    }

    return getScoped(state, pathOrFn, scope);
  }, [scope, store]);

  return useMemo(() => ({
    scope, store, getScopedState,
  }), [scope, store, getScopedState]);
};

export default useScope;
